/* ===== Community Page Service ===== */
import { showSnackbar } from '../utils/ui.js?v=83.58';
import { getCurrentSettings } from './settings.js?v=83.58';
import { getCurrentUser } from './auth.js?v=83.58';
import { getPublicClientSlug } from './public-client.js?v=83.58';
import { normalizePhone } from '../utils/helpers.js?v=83.58';
import { validateEmail, validatePhone } from '../utils/validation.js?v=83.58';
import { showPage } from '../ui/routing.js?v=83.58';
import { submitCommunityLeadBackend } from './backend.js?v=83.58';

let isSubmittingCommunityLead = false;
let communityOutsideCloseBound = false;

function getCommunityDefaultMessage() {
  return 'Vrei să fii primul care află ofertele noastre?';
}

function getCompanyNameForUi() {
  const settings = getCurrentSettings();
  const raw = String(settings?.companyName || '').trim();
  return raw || 'locația noastră';
}

function getCommunityMessageFromSettings() {
  const settings = getCurrentSettings();
  const custom = String(settings?.communityMessage || '').trim();
  return custom || getCommunityDefaultMessage();
}

export function applyCommunityUI() {
  const titleEl = document.getElementById('communityTitle');
  const msgEl = document.getElementById('communityMessageText');
  const mktLabelEl = document.getElementById('communityMarketingLabelText');
  const company = getCompanyNameForUi();

  if (titleEl) {
    titleEl.textContent = 'Alătură-te';
  }
  if (msgEl) {
    msgEl.textContent = getCommunityMessageFromSettings();
  }
  if (mktLabelEl) {
    mktLabelEl.textContent = `Sunt de acord să primesc oferte și comunicări de la ${company}`;
  }
}

export async function openCommunityPage() {
  const settings = getCurrentSettings();
  if (settings?.communityEnabled === false) {
    showSnackbar('Comunitatea locației nu este activă.');
    return;
  }
  await showPage('communityPage');
  const input = document.getElementById('communityContact');
  const marketing = document.getElementById('communityMarketing');
  if (input) input.value = '';
  if (marketing) marketing.checked = false;
  applyCommunityUI();
  bindCommunityOutsideClose();
}

function bindCommunityOutsideClose() {
  if (communityOutsideCloseBound) return;
  const shell = document.querySelector('#communityPage .community-page-shell');
  const card = document.querySelector('#communityPage .community-card');
  if (!shell || !card) return;

  shell.addEventListener('click', async (event) => {
    // Close only when tapping outside the popup card.
    if (event.target === shell) {
      await showPage('clientPage');
    }
  });

  card.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  communityOutsideCloseBound = true;
}

export async function submitCommunityLead() {
  if (isSubmittingCommunityLead) return;
  isSubmittingCommunityLead = true;

  const btn = document.getElementById('communitySubmitBtn');
  const originalText = btn?.textContent || 'Alătură-te';
  if (btn) {
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.textContent = 'Se trimite...';
  }

  try {
    const publicSlug = getPublicClientSlug();
    const user = getCurrentUser();
    if (!publicSlug && !user) {
      throw new Error('Sesiune invalidă. Reîncarcă pagina.');
    }

    const raw = String(document.getElementById('communityContact')?.value || '').trim();
    const accepted = document.getElementById('communityMarketing')?.checked === true;
    if (!raw) {
      throw new Error('Completează email sau telefon.');
    }
    if (!accepted) {
      throw new Error('Acordul de comunicare este obligatoriu.');
    }

    const isEmail = validateEmail(raw);
    const isPhone = validatePhone(raw);
    if (!isEmail && !isPhone) {
      throw new Error('Date de contact invalide (email sau telefon românesc).');
    }

    const normalizedContact = isEmail ? raw.toLowerCase() : normalizePhone(raw);
    const contactType = isEmail ? 'email' : 'phone';
    const settings = getCurrentSettings();

    await submitCommunityLeadBackend({
      publicSlug: publicSlug || null,
      contact: normalizedContact,
      contactType,
      marketingAccepted: true,
      source: publicSlug ? 'public-client' : 'merchant-client',
      companyName: settings?.companyName || null
    });

    showSnackbar('Te-ai alăturat comunității. Mulțumim!', 'success');
    await showPage('clientPage');
  } catch (e) {
    showSnackbar(e?.message || 'Nu am putut trimite datele. Încearcă din nou.', 'error');
  } finally {
    isSubmittingCommunityLead = false;
    if (btn) {
      btn.disabled = false;
      btn.style.pointerEvents = '';
      btn.textContent = originalText;
    }
  }
}

window.openCommunityPage = openCommunityPage;
window.submitCommunityLead = submitCommunityLead;
